import { merge_default_values } from '@/utils/mergeDefaultValue'
import {
  common_button_styles_fields,
  common_card_styles_fields,
  common_image_styles,
  common_sizes_fields,
  spacing_styles,
} from 'constant/CommonStylesData'
import { common_blocks_list, page_main_styles, row_col_styles } from './CommonBlocks'

import listings_icon from '/public/img/Product-hunt-cuate.svg'
import events_icon from '/public/img/Events-bro.svg'
import digital_icon from '/public/img/Digital-lifestyle-bro.svg'
import appointments_icon from '/public/img/Doctor-amico.svg'
import donation_icon from '/public/img/Charity-rafiki.svg'
import { layout_styles } from 'constant/LayoutStylesData'
import { typography_styles } from 'constant/TypographyStyles'
import { background_styles } from 'constant/BackgroundStyles'
import { border_styles } from 'constant/BordersStyle'
import { block_versions } from 'constant/Version'
import {
  normal_block_layout_styles,
  row_layout_styles,
  row_layout_styles_keys,
} from 'constant/RowLayout'

// all_listing_types
export const all_listing_types = [
  { label: 'Physical Product', value: 'listings', icon: listings_icon },
  { label: 'Event Booking', value: 'events', icon: events_icon },
  { label: 'Digital Product', value: 'digital', icon: digital_icon },
  { label: 'Appointment Booking', value: 'appointments', icon: appointments_icon },
  { label: 'Crowdfunding', value: 'donation', icon: donation_icon },
]

// order_type_filed
export const order_type_filed = {
  key: 'order_type',
  title: 'Listing type',
  type: 'multi-select',
  value: ['listings', 'events', 'digital', 'appointments', 'donation'],
  is_required: false,
  drop_down_values: all_listing_types,
}

// checkout main styles
const checkout_main_box_styles = {
  group_key: 'main_styles',
  group_title: 'Main styles',
  styles_list: [
    ...merge_default_values({
      all_items: common_card_styles_fields,
      default_values_items: [
        { key: 'padding_left', value: '16px' },
        { key: 'padding_right', value: '16px' },
        { key: 'padding_top', value: '18px' },
        { key: 'padding_bottom', value: '16px' },
        { key: 'top_left_border_radius', value: '8px' },
        { key: 'top_right_border_radius', value: '8px' },
        { key: 'bottom_left_border_radius', value: '8px' },
        { key: 'bottom_right_border_radius', value: '8px' },
      ],
    }),
  ],
}

// checkout_blocks_list
export const checkout_blocks_list = [
  {
    id: 1,
    title: 'Cart List',
    image: '/img/block-checkout-cart-list.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'my_cart_list',
      block_code: 1,
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      data_fields: [
        {
          key: 'enabled',
          title: 'Enabled',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        order_type_filed,
      ],
      styles_fields: [checkout_main_box_styles],
    },
  },
  {
    id: 1,
    title: 'Shipping/Service Methods List',
    image: '/img/block-checkout-shipping.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'shippings',
      block_code: 1,
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      data_fields: [
        {
          key: 'enabled',
          title: 'Enabled',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        order_type_filed,
      ],
      styles_fields: [checkout_main_box_styles],
    },
  },
  {
    id: 1,
    title: 'Shipment Methods List',
    image: '/img/sendcloud-5.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'shipments_method',
      block_code: 1,
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      data_fields: [
        {
          key: 'enabled',
          title: 'Enabled',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        order_type_filed,
      ],
      styles_fields: [checkout_main_box_styles],
    },
  },
  {
    id: 1,
    title: 'Payments',
    image: '/img/block-checkout-payment.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'payments',
      block_code: 1,
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      data_fields: [
        {
          key: 'enabled',
          title: 'Enabled',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        order_type_filed,
      ],
      styles_fields: [checkout_main_box_styles],
    },
  },
  {
    id: 1,
    title: 'Shipments List',
    image: '/img/block-checkout-shipments.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'shipments',
      block_code: 1,
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      data_fields: [
        {
          key: 'enabled',
          title: 'Enabled',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        order_type_filed,
      ],
      styles_fields: [checkout_main_box_styles],
    },
  },
  {
    id: 1,
    title: 'Cart Commissions',
    image: '/img/block-checkout-commishions.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'cart_commissions',
      block_code: 1,
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      data_fields: [
        {
          key: 'enabled',
          title: 'Enabled',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        order_type_filed,
      ],
      styles_fields: [checkout_main_box_styles],
    },
  },
  {
    id: 1,
    title: 'Demand Commissions',
    image: '/img/block-checkout-commishions.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'demand_commission',
      block_code: 1,
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      data_fields: [
        {
          key: 'enabled',
          title: 'Enabled',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        order_type_filed,
      ],
      styles_fields: [checkout_main_box_styles],
    },
  },
  {
    id: 1,
    title: 'Order summary',
    image: '/img/block-checkout-order-summary.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'order_summary',
      block_code: 1,
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      data_fields: [
        {
          key: 'enabled',
          title: 'Enabled',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        order_type_filed,
      ],
      styles_fields: [checkout_main_box_styles],
    },
  },
  {
    id: 1,
    title: 'Guest Checkout',
    image: '/img/guest_informartion.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'guest_information',
      block_code: 1,
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      data_fields: [
        {
          key: 'enabled',
          title: 'Enabled',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        {
          key: 'is_show_divider',
          title: 'Divider',
          type: 'switch',
          value: true,
        },
        {
          key: 'is_show_or',
          title: 'Divider',
          type: 'switch',
          value: true,
        },
        order_type_filed,
      ],
      styles_fields: [
        checkout_main_box_styles,
        {
          group_key: 'box_styles',
          group_title: 'Content Styles',
          styles_list: [
            ...background_styles,
            ...common_sizes_fields,
            ...merge_default_values({
              all_items: spacing_styles,
              default_values_items: [
                { key: 'padding_bottom', value: '8px' },
                { key: 'padding_top', value: '8px' },
                { key: 'padding_right', value: '8px' },
                { key: 'padding_left', value: '8px' },
              ],
            }),
            ...merge_default_values({
              all_items: layout_styles,
              default_values_items: [{ key: 'flex_direction', value: 'row' }],
            }),
          ],
        },
        {
          group_key: 'divider_styles',
          group_title: 'Divider styles',
          styles_list: [
            ...common_sizes_fields,
            ...background_styles,

            ...merge_default_values({
              all_items: spacing_styles,
              default_values_items: [],
            }),
            ...border_styles,
            {
              key: 'box_shadow',
              default_component_key: 'shadow',
              value: '0px 0px 0px 0px #ffffff',
              type: 'shadow-picker',
              title: 'Shadow',
            },
          ],
        },
        {
          group_key: 'or_styles',
          group_title: 'OR style',
          styles_list: [
            ...merge_default_values({
              all_items: [
                ...spacing_styles,
                ...background_styles,
                ...common_sizes_fields,
                ...typography_styles,
              ],
              default_values_items: [
                { key: 'max_width', value: '' },
                { key: 'width', value: '' },
                { key: 'padding_bottom', value: '0px' },
                { key: 'padding_bottom', value: '0px' },
                { key: 'padding_top', value: '0px' },
                { key: 'margin_right', value: '' },
                { key: 'margin_left', value: '' },
                { key: 'margin_top', value: '40%' },
                { key: 'padding_right', value: '8px' },
                { key: 'padding_left', value: '8px' },
                { key: 'text_size', value: '40px' },
                { key: 'text_color', value: '#004327' },
                { key: 'font_weight', value: '700' },
              ],
            }),
          ],
        },
      ],
    },
  },
  {
    id: 1,
    title: 'Schedules',
    image: '/img/block-checkout-schedules.png',
    type: 'marketplace,single_shop',
    restricted_plans: ['community_monthly'],
    properties: {
      block: 'schedules',
      block_code: 1,
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      data_fields: [
        {
          key: 'enabled',
          title: 'Enabled',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        order_type_filed,
      ],
      styles_fields: [checkout_main_box_styles],
    },
  },
  // {
  //   id: 1,
  //   title: 'Pricing Rules (connected with schedule)',
  //   image: '/img/block-checkout-schedules.png',
  //   type: 'marketplace,single_shop',
  //   properties: {
  //     block: 'pricing_rules_by_schedule',
  //     block_code: 1,
  //     isStatic: true,
  //     block_data_key: '',
  //     fetch_by: {},
  //     data_fields: [
  //       {
  //         key: 'enabled',
  //         title: 'Enabled',
  //         type: 'switch',
  //         value: true,
  //         isShowWithTitle: true,
  //       },
  //       order_type_filed,
  //     ],
  //     styles_fields: [checkout_main_box_styles],
  //   },
  // },
  {
    id: 1,
    title: 'Cart Item Attributes',
    image: '/img/block-cart-attributes.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'cart_item_attributes',
      block_code: 1,
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      data_fields: [
        {
          key: 'enabled',
          title: 'Enabled',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        {
          key: 'title',
          title: 'Attribute Form Title',
          type: 'switch',
          type: 'input',
          value: 'Passenger Info {index}',
          isShowTranslation: true,
        },
        order_type_filed,
      ],
      styles_fields: [
        checkout_main_box_styles,
        {
          group_key: 'attributes_list_styles',
          group_title: 'Attributes styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [{ key: 'margin_bottom', value: '24px' }],
            }),
            ...merge_default_values({
              all_items: row_layout_styles,
              default_values_items: [{ key: 'columns_box_percentage', value: '48% 48%' }],
            }),
            ,
          ],
        },
        {
          group_key: 'title_style',
          group_title: 'Title styles',
          styles_list: merge_default_values({
            all_items: [
              ...typography_styles,
              ...layout_styles,
              ...spacing_styles,
              ...common_sizes_fields,
            ],
            default_values_items: [
              {
                key: 'text_size',
                value: '18px',
              },
              {
                key: 'line_height',
                value: '18px',
              },
              {
                key: 'text_color',
                value: '#000000',
              },
              {
                key: 'margin_bottom',
                value: '4px',
              },
            ],
          }),
        },
      ],
    },
  },
  {
    id: 1,
    title: 'Checkout button',
    image: '/img/block-checkout-checkout.png',
    type: 'marketplace,single_shop',
    properties: {
      block: 'checkout_button',
      block_code: 1,
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      data_fields: [
        {
          key: 'enabled',
          title: 'Enabled',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        {
          key: 'is_icon_in_right',
          title: 'Icon in right',
          type: 'switch',
          value: false,
        },
        {
          key: 'version',
          type: 'input',
          value: block_versions.checkout_button,
          is_show: false,
        },
        order_type_filed,
        {
          key: 'icon',
          title: 'Icon',
          type: 'image',
          value: '',
          is_required: false,
        },
      ],
      styles_fields: [
        {
          group_key: 'main_styles',
          group_title: 'Block styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),
          ],
        },
        {
          group_key: 'box_styles',
          group_title: 'Content styles',
          styles_list: [
            ...merge_default_values({
              all_items: common_card_styles_fields,
              default_values_items: [],
            }),
          ],
        },
        {
          group_key: 'button_styles',
          group_title: 'Button styles',
          styles_list: [...common_button_styles_fields],
        },
        {
          group_key: 'text_styles',
          group_title: 'Title text styles',
          styles_list: [...typography_styles],
        },
        {
          group_key: 'icon_styles',
          group_title: 'Icon styles',
          styles_list: [, ...common_image_styles],
        },
      ],
    },
  },

  {
    id: 14,
    title: 'Heading (h3)',
    image: '/img/block-heading.png',
    type: '',
    properties: {
      block: 'heading2_block',
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      isShowTranslation: true,
      data_fields: [
        {
          key: 'title',
          title: 'Text',
          type: 'input',
          value: '',
          is_required: true,
          isShowTranslation: true,
        },
      ],
      styles_fields: [
        checkout_main_box_styles,
        {
          group_key: 'text_styles',
          group_title: 'Text styles',
          styles_list: typography_styles,
        },
      ],
    },
  },
  {
    id: 13,
    title: 'Anonymous donation',
    image: '/img/donate-anonymously.png',
    type: '',
    properties: {
      block: 'anonymous_donation_checkup',
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      isShowTranslation: true,
      data_fields: [
        {
          key: 'enabled',
          title: 'Enabled',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        order_type_filed,
        {
          key: 'title',
          title: 'Text',
          type: 'input',
          value: '',
          is_required: true,
          isShowTranslation: true,
        },
      ],
      styles_fields: [
        checkout_main_box_styles,

        {
          group_key: 'checkbox_line_style',
          group_title: 'Checkbox line styles',
          styles_list: merge_default_values({
            all_items: [...typography_styles, ...layout_styles, ...spacing_styles],
            default_values_items: [
              {
                key: 'flex_direction',
                value: 'row',
              },
              {
                key: 'align_items',
                value: 'center',
              },
              {
                key: 'justify_content',
                value: 'space-between',
              },

              {
                key: 'text_size',
                value: '14px',
              },
              {
                key: 'line_height',
                value: '14px',
              },
              {
                key: 'text_color',
                value: '#3E3D3D',
              },
              {
                key: 'margin_top',
                value: '8px',
              },
            ],
          }),
        },
      ],
    },
  },
  {
    id: 13,
    title: 'Passenger Details',
    image: '/img/donate-anonymously.png',
    type: '',
    properties: {
      block: 'passenger_details',
      isStatic: true,
      block_data_key: '',
      fetch_by: {},
      isShowTranslation: true,
      data_fields: [
        {
          key: 'enabled',
          title: 'Enabled',
          type: 'switch',
          value: true,
          isShowWithTitle: true,
        },
        order_type_filed,
      ],
      styles_fields: [checkout_main_box_styles],
    },
  },

  ...common_blocks_list,
]

//
export const checkout_block_styles = row_col_styles

export const checkout_main_styles = page_main_styles
